import { Routes } from '@angular/router';

import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

export const routes: Routes = [
  // { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'logged',
    loadComponent: () =>
      import('./features/auth/pages/callback/callback.component').then(
        (m) => m.CallbackComponent,
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layouts/blank-shell/blank-shell.component').then(
        (m) => m.BlankShellComponent,
      ),
    canActivate: [autoLoginPartialRoutesGuard],

    children: [
      {
        path: 'onboarding',
        loadChildren: () =>
          import('./features/onboarding/onboarding.routes').then(
            (m) => m.ONBOARDING_ROUTES,
          ),
        data: { breadcrumb: 'shared.breadcrumb.routes.onboarding' },
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/errors/errors.routes').then((m) => m.ERROR_ROUTES),
        data: { breadcrumb: null },
      },
    ],
  },

  // Privadas
  {
    path: '',
    loadComponent: () =>
      import('./layouts/app-shell/app-shell.component').then(
        (m) => m.AppShellComponent,
      ),
    canActivate: [autoLoginPartialRoutesGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/reports/reports.routes').then(
            (m) => m.REPORTS_ROUTES,
          ),
        data: { breadcrumb: 'shared.breadcrumb.routes.reports' },
      },
      {
        path: 'overview',
        loadChildren: () =>
          import('./features/hubs/hubs.routes').then((m) => m.HUBS_ROUTES),
        data: { breadcrumb: 'shared.breadcrumb.routes.overview' },
      },
      {
        path: 'success',
        loadChildren: () =>
          import('./features/success/success.routes').then(
            (m) => m.SUCCESS_ROUTES,
          ),
        data: { breadcrumb: 'shared.breadcrumb.routes.success' },
      },
      {
        path: 'intelligence',
        loadChildren: () =>
          import('./features/ai/ai-report.routes').then((m) => m.AI_ROUTES),
        data: { breadcrumb: 'shared.breadcrumb.routes.intelligence' },
      },
      {
        path: 'agents',
        loadChildren: () =>
          import('./features/ai-agents/ai-agents.routes').then(
            (m) => m.AI_AGENTS_ROUTES,
          ),
        data: { breadcrumb: 'shared.breadcrumb.routes.agents' },
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then(
            (m) => m.SETTINGS_ROUTES,
          ),
        data: { breadcrumb: 'shared.breadcrumb.routes.settings' },
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  // fallback - página 404
  //
  // Vai dentro do blank-shell (sem guard, ao contrário do bloco de rotas de
  // erro autenticadas) porque é o shell que aplica `bg-background` e centraliza
  // o conteúdo. Solta, a rota não tinha nenhum elemento pintando o fundo: o
  // `body` ficava transparente e, em navegador com tema escuro sem a classe
  // `.dark` aplicada, o título em `text-foreground` sumia contra o preto do
  // próprio navegador.
  {
    path: '',
    loadComponent: () =>
      import('./layouts/blank-shell/blank-shell.component').then(
        (m) => m.BlankShellComponent,
      ),
    children: [
      {
        path: '**',
        loadComponent: () =>
          import('./features/errors/pages/not-found/not-found.component').then(
            (m) => m.NotFoundComponent,
          ),
      },
    ],
  },
];
